import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/regulatory-affairs/combination-products")({
  head: () => buildRouteHead("/en/services/regulatory-affairs/combination-products", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/industries/combination-products", replace: true });
  },
});
